import { render, staticRenderFns } from "./VehiclesEdit.vue?vue&type=template&id=49a7a40f&scoped=true"
import script from "./VehiclesEdit.vue?vue&type=script&lang=js"
export * from "./VehiclesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7a40f",
  null
  
)

export default component.exports